import { ReactComponent as AnBracket } from './angle-bracket.svg';
import filterPhoto from './thumbnail_FilterMan.jpg';
import insulationPhoto from './thumbnail_InsulationMan.jpg';


const AngleBracket = ({fill, stroke, isOpen}:{fill:string, stroke:string; isOpen: boolean;}) => (
  <div  className={`angleBracketHolder ${isOpen?'open':'closed'}`}>
    <AnBracket fill={fill} stroke={stroke} />
  </div>
);





export default {AngleBracket, filterPhoto, insulationPhoto};
